module.exports = __webpack_public_path__ + "static/media/business insight.2321199b.svg";